import { forwardRef } from "react";

/* Simple congratulatory achievement badge (600x600) — Tux medallion + message.
   Awarded per completed lab; nudges the learner to the next certification step. */
const Badge = forwardRef(function Badge({ achievementTitle }, ref) {
  return (
    <div
      ref={ref}
      style={{
        width: 600, height: 600, boxSizing: "border-box",
        background: "radial-gradient(120% 120% at 50% 0%, #123a3f 0%, #0b2a2e 55%, #071d21 100%)",
        fontFamily: '"Helvetica Neue", Arial, sans-serif', color: "#eaf6f6",
        position: "relative", padding: 40, textAlign: "center",
        display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 26,
      }}
    >
      <div style={{ position: "absolute", inset: 20, border: "2px solid rgba(201,162,39,0.55)", borderRadius: "50%" }} />

      {/* Gold medallion with Tux */}
      <div style={{ position: "relative", width: 240, height: 240 }}>
        <div style={{
          position: "absolute", inset: 0, borderRadius: "50%",
          background: "conic-gradient(#c9a227, #f4d675, #c9a227, #a9861d, #f4d675, #c9a227)",
          display: "grid", placeItems: "center", boxShadow: "0 12px 48px rgba(0,0,0,0.5)",
        }}>
          <div style={{ width: 196, height: 196, borderRadius: "50%", background: "#0b2a2e", display: "grid", placeItems: "center", border: "4px solid #071d21" }}>
            <div style={{ fontSize: 96, lineHeight: 1 }}>🐧</div>
          </div>
        </div>
      </div>

      {/* Congratulations message */}
      <div style={{ maxWidth: 460 }}>
        <div style={{ fontFamily: 'Georgia, serif', fontWeight: 900, fontSize: 40, color: "#f4d675", letterSpacing: 1 }}>
          Congratulations!
        </div>
        <div style={{ fontSize: 17, color: "#dff1f1", marginTop: 12, lineHeight: 1.55 }}>
          You&rsquo;ve earned the <span style={{ fontWeight: 700, color: "#ffffff" }}>{achievementTitle}</span> badge.
          Proceed to the next step of the certification process.
        </div>
      </div>
    </div>
  );
});

export default Badge;
